import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, Sparkles, Smartphone, Stethoscope, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function WhyFailSection() {
  const {
    t
  } = useLanguage();
  const failures = [{
    icon: ShoppingBag,
    title: t('whyFail.f1_title'),
    description: t('whyFail.f1_desc')
  }, {
    icon: Smartphone,
    title: t('whyFail.f2_title'),
    description: t('whyFail.f2_desc')
  }, {
    icon: Sparkles,
    title: t('whyFail.f3_title'),
    description: t('whyFail.f3_desc')
  }, {
    icon: Stethoscope,
    title: t('whyFail.f4_title'),
    description: t('whyFail.f4_desc')
  }];
  return <section className="py-12 md:py-24 bg-brand-dark text-white relative" data-id="element-497" data-mp="1ud8dot5ov05l">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-498" data-mp="1ufbco2otk3mg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16 max-w-3xl mx-auto" data-id="element-499" data-mp="wxbbqmhdchsa">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-gold-light mb-4 md:mb-6" data-id="element-500" data-mp="34jeecokwii3q">
            {t('whyFail.title')}
          </h2>
          <p className="text-lg text-gray-300" data-id="element-501" data-mp="2zr4unqadqe9w">{t('whyFail.subtitle')}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-502" data-mp="2vr43d526m8lf">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 p-8 rounded-sm hover:bg-white/10 transition-colors" data-id="element-503" data-mp="2qtugnx66gb1a" data-mpi={index}>
              <div className="flex items-start" data-id="element-504" data-mp="f1p3gu790njq">
                <div className="flex-shrink-0 relative" data-id="element-505" data-mp="b15am2tpk63e">
                  <div className="w-12 h-12 bg-brand-gold/20 rounded-full flex items-center justify-center text-brand-gold-light" data-id="element-506" data-mp="b2gahrk18tp8">
                    <item.icon className="w-6 h-6" data-id="element-507" data-mp="24i18ffhk0r0l" />
                  </div>
                  <div className="absolute -bottom-1.5 -right-1.5 w-5 h-5 flex items-center justify-center" data-id="element-508" data-mp="29c5ii7m49f5w">
                    <svg viewBox="0 0 20 20" className="w-5 h-5" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-509" data-mp="1vh31aobtk3ds">
                      <circle cx="10" cy="10" r="9" stroke="rgba(183,135,98,0.5)" strokeWidth="1" fill="rgba(60,40,30,0.85)" data-id="element-510" data-mp="1ziet90i610p5" />
                      <path d="M7 7l6 6M13 7l-6 6" stroke="rgba(183,135,98,0.8)" strokeWidth="1.2" strokeLinecap="round" data-id="element-511" data-mp="2s9yjv5h3dh16" />
                    </svg>
                  </div>
                </div>
                <div className="ml-6" data-id="element-512" data-mp="2j8i8ovigdavw">
                  <h3 className="text-xl font-serif text-white mb-3" data-id="element-513" data-mp="2j7fg8j5hf0dv">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-514" data-mp="12wlcf7doncvu">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-515" data-mp="zenr3f8ejrcv">
          <p className="text-xl text-brand-gold-light font-medium mb-4" data-id="element-516" data-mp="14cz2vvi9cbxq">
            {t('whyFail.conclusion1')}
          </p>
          <p className="text-2xl md:text-3xl font-serif" data-id="element-517" data-mp="gk0hy5hcr7hj">
            {t('whyFail.conclusion2')}
          </p>
        </motion.div>
      </div>
    </section>;
}